// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-o_fw","galleryItem_borderTopRadius":"c-o_fx","galleryItem__image":"c-o_fy"};